"use strict";
exports.__esModule = true;
var axios_1 = require("axios");
var querystring_1 = require("querystring");
var utils_1 = require("../utils");
var BaseClient = /** @class */ (function () {
    /**
     * @param debug 是否启动调试
     * @param reqInterceptor 请求拦截器
     * @param respInterceptors 响应拦截器
     */
    function BaseClient(debug, reqInterceptor, respInterceptors, axiosConfig) {
        if (debug === void 0) { debug = true; }
        var _this = this;
        // 请求成功的状态码
        this.successCode = 21020000;
        this.axios = axios_1["default"].create(axiosConfig);
        this.debug = debug;
        this.axios.interceptors.request.use(function (req) {
            if (_this.debug) {
                _this.consoleReq(req);
            }
            if (reqInterceptor) {
                reqInterceptor(req);
            }
            return req;
        });
        this.axios.interceptors.response.use(function (resp) {
            if (_this.debug) {
                _this.consoleResp(resp);
            }
            if (respInterceptors) {
                respInterceptors(resp);
            }
            return resp;
        });
        this.secret = new utils_1.Secret();
    }
    BaseClient.prototype.getAxios = function () {
        return this.axios;
    };
    /**
     * Http请求
     * @param url 请求地址url
     * @param headers
     * @param method get or post
     * @param data
     * @param form data是否用form形式传输
     */
    BaseClient.prototype.fetch = function (url, headers, method, data, form, params) {
        if (headers === void 0) { headers = {}; }
        if (form === void 0) { form = false; }
        if (form) {
            if (/elong/.test(url)) {
                return this.axios.request({
                    url: url,
                    method: method,
                    headers: headers,
                    params: params,
                    data: data || {}
                });
            }
            else {
                return this.axios.request({
                    url: url,
                    method: method,
                    headers: headers,
                    params: params,
                    data: querystring_1.stringify(data) || undefined
                });
            }
        }
        else {
            return this.axios.request({
                url: url,
                method: method,
                headers: headers,
                params: params,
                data: data ? data : undefined
            });
        }
    };
    BaseClient.prototype.fetchPHP = function (url, method, data, params) {
        return this.axios.request({ url: url, method: method, data: data, params: params });
    };
    /**
     * 发送 GET 请求
     */
    BaseClient.prototype.get = function (url, headers) {
        if (headers === void 0) { headers = {}; }
        return this.fetch(url, headers, 'get', undefined);
    };
    /**
     * 发送 POST 请求
     */
    BaseClient.prototype.post = function (url, headers, data) {
        if (headers === void 0) { headers = {}; }
        return this.fetch(url, headers, 'post', data);
    };
    BaseClient.prototype.consoleReq = function (req) {
        // tslint:disable-next-line:no-console
        console.log("\n    [Request sending]\n    >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>\n    >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>\n    >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>\n\n    url: " + req.url + "\n\n    ");
        for (var key in req.headers) {
            if (req.headers.hasOwnProperty(key)) {
                var element = req.headers[key];
                // tslint:disable-next-line:no-console
                console.log("    " + key + ":" + JSON.stringify(element));
            }
        }
        // tslint:disable-next-line:no-console
        console.log("\n    method: " + req.method + "\n\n    data: " + JSON.stringify(req.data) + "\n\n    >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>\n    ");
    };
    BaseClient.prototype.consoleResp = function (resp) {
        // tslint:disable-next-line:no-console
        console.log("\n\n\n\n\n    [Response receiving]\n    <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<\n    <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<\n    <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<\n\n    url: " + resp.config.url + "\n\n    method: " + resp.config.method + "\n\n    http status: " + resp.status + "\n\n    data: " + JSON.stringify(resp.data) + "\n\n    <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<\n\n\n\n\n    ");
    };
    return BaseClient;
}());
exports.BaseClient = BaseClient;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/base.js
// module id = 7
// module chunks = 44